import React, { Component } from 'react';
import { Modal, Select, Tree, Spin, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const Option = Select.Option;
const TreeNode = Tree.TreeNode;

/**
 * 部门文件夹迁移到项目内 弹框组件
 * @ClassName FolderMoveToInv
 * @Author nrj
 * @Date 2026/7/8
 */
class FolderMoveToInv extends Component {

    state = {
        visible: false,
        loading: false,
        projects: [],           // 项目列表
        projectLoading: false,  // 项目列表加载中
        selectedInvId: null,    // 选中的项目ID
        selectedInvName: '',    // 选中的项目名称
        selectedRoleCode: null, // 选中的项目角色编码
        treeData: null,         // 项目目录树
        treeLoading: false,     // 目录树加载中
        selectedCatalogId: null, // 选中的目标目录ID
        expandedKeys: [],
        autoExpandParent: true,
        selectedKeys: [],
        deptCatalogId: null,   // 要迁移的部门目录ID
        deptCatalogName: '',   // 要迁移的部门目录名称
    };

    /**
     * 显示弹框
     */
    show = (deptCatalogId, deptCatalogName) => {
        this.setState({
            visible: true,
            deptCatalogId,
            deptCatalogName,
            selectedInvId: null,
            selectedInvName: '',
            selectedRoleCode: null,
            treeData: null,
            selectedCatalogId: null,
            expandedKeys: [],
            selectedKeys: [],
            autoExpandParent: true,
        }, () => {
            this.loadProjects();
        });
    };

    /**
     * 加载用户可操作的项目列表
     */
    loadProjects = () => {
        this.setState({ projectLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.deptFile.queryMoveProjects,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { projects = [] } = res;
                this.setState({
                    projects,
                    projectLoading: false,
                });
            },
            errorResult: () => {
                this.setState({ projectLoading: false });
                message.error('加载项目列表失败');
            }
        };
        $.sendRequest(options);
    };

    /**
     * 选择/清空项目后加载项目目录树
     */
    onProjectChange = (value) => {
        if (!value) {
            // 清空选择
            this.setState({
                selectedInvId: null,
                selectedInvName: '',
                selectedRoleCode: null,
                selectedCatalogId: null,
                treeData: null,
                expandedKeys: [],
                selectedKeys: [],
            });
            return;
        }
        const { projects } = this.state;
        const selected = projects.find(p => p.investigationId == value);
        this.setState({
            selectedInvId: value,
            selectedInvName: selected ? selected.investigationName : '',
            selectedRoleCode: selected ? selected.roleCode : null,
            selectedCatalogId: null,
            treeData: null,
            expandedKeys: [],
            selectedKeys: [],
            treeLoading: true,
        }, () => {
            this.loadCatalogTree(value);
        });
    };

    /**
     * 加载项目目录树（过滤掉不能新增子目录的文件夹）
     */
    loadCatalogTree = (invId) => {
        const { selectedRoleCode } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.invFolder.queryInvCatalogTreeForMoveFolder,
            data: { invId, curRoleCode: selectedRoleCode },
            dataType: 'json',
            doneResult: res => {
                const { catalogs } = res;
                this.setState({
                    treeData: catalogs ? [catalogs] : [],
                    treeLoading: false,
                });
            },
            errorResult: () => {
                this.setState({ treeLoading: false });
                message.error('加载项目目录失败');
            }
        };
        $.sendRequest(options);
    };

    /**
     * 展开/收起节点
     */
    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

    /**
     * 选择目录节点
     */
    onSelect = (selectedKeys) => {
        this.setState({
            selectedKeys,
            selectedCatalogId: selectedKeys.length > 0 ? Number(selectedKeys[0]) : null,
        });
    };

    /**
     * 确认迁移
     */
    handleOk = () => {
        const { deptCatalogId, selectedInvId, selectedCatalogId } = this.state;

        if (!deptCatalogId) {
            message.error('部门目录ID不能为空');
            return;
        }
        if (!selectedInvId) {
            message.warning('请选择项目');
            return;
        }

        Modal.confirm({
            title: '确认迁移',
            content: '确定要将该文件夹迁移到所选项目中吗？',
            onOk: () => {
                this.doMove();
            },
        });
    };

    /**
     * 执行迁移
     */
    doMove = () => {
        const { deptCatalogId, selectedInvId, selectedCatalogId } = this.state;
        this.setState({ loading: true });

        const data = {
            deptCatalogId,
            invId: selectedInvId,
        };
        if (selectedCatalogId) {
            data.targetCatalogId = selectedCatalogId;
        }

        const options = {
            method: 'POST',
            url: API_URL.deptFile.moveFolderToInv,
            data,
            dataType: 'json',
            doneResult: res => {
                this.setState({ loading: false });
                message.success(res.success || '迁移成功');
                this.handleCancel();
                // 刷新外部数据
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            },
            errorResult: (err) => {
                this.setState({ loading: false });
                message.error(err && err.message ? err.message : '迁移失败');
            }
        };
        $.sendRequest(options);
    };

    /**
     * 关闭弹框
     */
    handleCancel = () => {
        this.setState({
            visible: false,
            projects: [],
            treeData: null,
            selectedInvId: null,
            selectedInvName: '',
            selectedCatalogId: null,
            deptCatalogId: null,
            expandedKeys: [],
            selectedKeys: [],
            loading: false,
        });
    };

    /**
     * 渲染目录树节点
     */
    renderTreeNodes = (data) => {
        if (!data || data.length === 0) return null;
        return data.map(item => {
            const { id, catalogName, children } = item;
            const title = (
                <span style={{ fontSize: 13 }}>{catalogName}</span>
            );
            if (children && children.length > 0) {
                return (
                    <TreeNode key={String(id)} title={title}>
                        {this.renderTreeNodes(children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={String(id)} title={title} />;
        });
    };

    /**
     * 项目搜索过滤
     */
    filterProject = (input, option) => {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    render() {
        const {
            visible, loading, projects, projectLoading,
            selectedInvId, treeData, treeLoading,
            expandedKeys, autoExpandParent, selectedKeys,
            deptCatalogName,
        } = this.state;

        return (
            <Modal
                title="文件夹迁移到项目内"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                confirmLoading={loading}
                okText="确认迁移"
                cancelText="取消"
                width={520}
                bodyStyle={{ maxHeight: 500, overflowY: 'auto' }}
            >
                <div style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 8, fontWeight: 'bold' }}>
                        请选择项目：
                    </div>
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        placeholder="搜索并选择项目"
                        optionFilterProp="children"
                        loading={projectLoading}
                        notFoundContent={projectLoading ? <Spin size="small" /> : '暂无项目数据'}
                        filterOption={this.filterProject}
                        onChange={this.onProjectChange}
                        value={selectedInvId}
                        allowClear
                    >
                        {projects.map(p => (
                            <Option key={p.investigationId} value={p.investigationId}>
                                {p.investigationName}
                            </Option>
                        ))}
                    </Select>
                </div>

                <div>
                    <div style={{ marginBottom: 8, fontWeight: 'bold' }}>
                        请选择路径（可选，不选则自动在项目文档下创建同名目录）：
                    </div>
                    <div
                        style={{
                            border: '1px solid #d9d9d9',
                            borderRadius: 4,
                            padding: '8px 12px',
                            minHeight: 120,
                            maxHeight: 280,
                            overflow: 'auto',
                            backgroundColor: '#fff',
                        }}
                    >
                        {!selectedInvId ? (
                            <div style={{ color: '#999', textAlign: 'center', paddingTop: 40 }}>
                                请先选择项目
                            </div>
                        ) : treeLoading ? (
                            <div style={{ textAlign: 'center', paddingTop: 40 }}>
                                <Spin tip="加载目录中..." />
                            </div>
                        ) : treeData && treeData.length > 0 ? (
                            <Tree
                                expandedKeys={expandedKeys}
                                selectedKeys={selectedKeys}
                                autoExpandParent={autoExpandParent}
                                onExpand={this.onExpand}
                                onSelect={this.onSelect}
                            >
                                {this.renderTreeNodes(treeData)}
                            </Tree>
                        ) : (
                            <div style={{ color: '#999', textAlign: 'center', paddingTop: 20 }}>暂无目录数据</div>
                        )}
                    </div>
                    <div style={{ color: '#888', fontSize: 12, marginTop: 4 }}>
                        当前待迁移目录：<strong>{deptCatalogName || '未知'}</strong>
                        &nbsp;（一级目录不允许迁移）
                    </div>
                </div>
            </Modal>
        );
    }
}

export default FolderMoveToInv;



// WEBPACK FOOTER //
// ./src/components/documentManagement/departmentalDocuments/FolderMoveToInv.js